import React from 'react';
import { Input } from '../components/ui/input';

/**
 * Aplica máscara de telefone celular brasileiro: (XX) XXXXX-XXXX
 */
export const formatPhone = (value) => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

export const PhoneInput = React.forwardRef(({ value, onChange, ...props }, ref) => {
  const handleChange = (e) => {
    const formatted = formatPhone(e.target.value);
    onChange({ target: { value: formatted } });
  };

  return (
    <Input
      ref={ref}
      type="tel"
      value={value || ''}
      onChange={handleChange}
      placeholder="(00) 00000-0000"
      maxLength={15}
      {...props}
    />
  );
});

PhoneInput.displayName = 'PhoneInput';
